/* eslint-disable */
import { getNethpHref } from '@jdhfe/seouifuncs/dist/tools/getNethpHref';
import { checkIsSeo } from '@jdhfe/seouifuncs/dist/seo/getRelSeoUrl';

// 登录组件配置
export const loginOptions = {
  protocol: process.env.REACT_APP_LOGIN_OPTIONS_PROTOCOL,
  // 选填----默认空字符串：ERP和JDPIN两种登录方式。ERP: 只有ERP一种登录方式。JDPIN：只有JDPIN一种登录方式。
  onlyOneLoginType: process.env.REACT_APP_LOGIN_OPTIONS_ONLY_ONE_LOGIN_TYPE,
  // 必填----登录类型： ERP、JDPIN
  loginType: process.env.REACT_APP_LOGIN_OPTIONS_LOGIN_TYPE,
  // 选填----JDPIN登录按钮的样式配置码，passport.jd.com里面会根据这个参数设置对应的按钮样式
  btnTag: process.env.REACT_APP_LOGIN_OPTIONS_BTN_TAG,
  // 必填----这个需要向passport.jd.com那边申请个自己应用的ID
  from: process.env.REACT_APP_LOGIN_OPTIONS_FROM,
  // 必填----登录页面的URL, 可以不需要带协议和域名
  loginUrl: process.env.REACT_APP_LOGIN_OPTIONS_LOGIN_URL,
};

/**
 * @desc 获取UUID的字符串函数
 * @returns 返回唯一串
 */
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 将键名和键值添加或者替换URL中的值
 * @param url 字符串URL链接
 * @param name 参数键名
 * @param value 参数键值
 * @returns 新的字符串URL链接
 */
export function addParamToUrlStr(url: any, name: any, value: any) {
  let newUrl = '';
  const reg: any = new RegExp(`(^|)${name}=([^&]*)(|$)`);
  const tmp = `${name}=${value}`;
  if (url.match(reg) !== null) {
    newUrl = url.replace(reg, tmp);
  } else if (url.match('[\\?]')) {
    newUrl = `${url}&${tmp}`;
  } else {
    newUrl = `${url}?${tmp}`;
  }
  return newUrl;
}

/**
 * @desc 日期格式化函数
 * @param date js Date对象
 * @param fmt 年:y, 月：M, 日：d, 小时: h, 分：m, 秒：s, 毫秒：q
 * @returns 返回格式化的日期字符串
 */
export function dateFormat(date: Date, fmt: string) {
  let res = fmt;
  const o: any = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(res)) {
    res = res.replace(RegExp.$1, `${date.getFullYear()}`.substr(4 - RegExp.$1.length));
  }
  Object.keys(o).forEach((k: any) => {
    if (new RegExp(`(${k})`).test(res)) {
      res = res.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length));
    }
  });
  return res;
}
/**
 * @desc 获取url参数
 * @param name 参数key值
 * @returns 参数值
 */
export function getQueryString(name: string) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURI(r[2]);
  return null;
}

/**
 * 遍历树结构
 * @param node 被遍历的树的根节点
 * @param nodeArr node节点所在的数组
 * @param cb 返回true，停止遍历
 */
export function iteratorTree(node: any, nodeArr: any[], cb: Function) {
  const isEnd = cb(node, nodeArr);
  if (isEnd === true) {
    return true;
  }
  if (node.children && node.children.length > 0) {
    for (let i = 0; i < node.children.length; i += 1) {
      const ended = iteratorTree(node.children[i], node.children, cb);
      if (ended === true) {
        return true;
      }
    }
  }
  return false;
}
/**
 * 遍历树结构
 * @param node 被遍历的树的根节点
 * @param nodeArr node节点所在的数组
 * @param cb 返回true，只停止当前节点继续遍历
 */
export function iteratorTree1(node: any, nodeArr: any[], cb: Function) {
  const isEnd = cb(node, nodeArr);
  if (isEnd === true) {
    return true;
  }
  if (node.children && node.children.length > 0) {
    for (let i = 0; i < node.children.length; i += 1) {
      iteratorTree(node.children[i], node.children, cb);
    }
  }
  return false;
}
// 为每个树节点设置父节点
export function setTreeParentNode(treeNodes: any) {
  const setParentNode = (node: any) => {
    if (node.children && node.children.length > 0) {
      node.children.forEach((childNode: any) => {
        childNode.parent = node;
        setParentNode(childNode);
      });
    }
  };
  treeNodes.forEach((node: any) => {
    setParentNode(node);
  });
}
// 根据子节点获取最近的一个父级菜单
export function getNearestAsideMenuParentNode(node: any): any {
  if (node.asideMenu) {
    return node;
  }
  if (node.parent) {
    return getNearestAsideMenuParentNode(node.parent);
  }
  return node;
}
// 根据子节点遍历所有父节点
export function iteratorParentNode(node: any, cb: Function) {
  cb(node);
  if (node.parent) {
    iteratorParentNode(node.parent, cb);
  }
}
// 绑定事件兼容代码
export function addEventListener(el: any, type: string, func: Function) {
  if (el.addEventListener) {
    el.addEventListener(type, func, false);
  } else if (el.attachEvent) {
    el.attachEvent(`on${type}`, func);
  } else {
    el[`on${type}`] = func;
  }
}
// 绑定事件兼容代码
export function removeEventListener(el: any, type: string, func: Function) {
  if (el.removeEventListener) {
    el.removeEventListener(type, func, false);
  } else if (el.attachEvent) {
    el.detachEvent(`on${type}`, func);
  } else {
    el[`on${type}`] = null;
  }
}
export const Cookie = {
  // 获取cookie、
  getCookie(name: string) {
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const arr = document.cookie.match(reg);
    if (arr) {
      return decodeURIComponent(arr[2]);
    }
    return null;
  },

  // 设置cookie
  setCookie(c_name: string, value: string, expiredays: string) {
    const exdate = new Date();
    // @ts-ignore
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = `${c_name}=${encodeURIComponent(value)}${
      // @ts-ignore
      expiredays == null ? '' : `;expires=${exdate.toGMTString()}`
    };path=/;domain=.jd.com`;
  },

  // 删除cookie
  delCookie(name: string) {
    const exp = new Date();
    exp.setTime(exp.getTime() - 1);
    const cval = Cookie.getCookie(name);
    // @ts-ignore
    document.cookie = `${name}=${cval};expires=${exp.toGMTString()};path=/`;
  },
};

export function clearHtmlTag(str: string) {
  return str.replace(/<[^>]+>/g, '');
}

export const toFixed = (num: any, digit: any) => {
  try {
    num = parseFloat(num);
  } catch (e) {
    num = 0;
  }
  return num.toFixed(digit);
};

export const getMinValueFromArray = (jsonArray:any, key:any) => {
  if (!jsonArray || !jsonArray.length) {
    return '0';
  }

  const reg = /\d+/g;
  const copiedArray = jsonArray.slice();
  copiedArray.sort((a:any, b:any) => a[key] - b[key]);

  let minValue = copiedArray[0][key] || '0';

  minValue = parseFloat(minValue);

  return toFixed(minValue, 2);
};
// 跳转
export const onClickhref = (url: any) => {
  window.location.href = url;
};

export const isJsonObj = (str: string) => {
  try {
      if (typeof JSON.parse(str) == "object") {
          return true;
      }
  } catch(e) {
  }
  return false;
}

export const targetLink = async (url:any, callback?:Function) => {
  const isSeo = await checkIsSeo();
  let openUrl:string = url || '/';
  if(isSeo){
    let _url = url;
    if(url && (url.indexOf('http://') > -1 || url.indexOf('https://') > -1 || url.indexOf('//') > -1)){
      console.log('getRealHref===>', url);
    }else{
      console.log('getRealHref===>', 'https://jdhcont.healthjd.com' + (url || '/'));
      _url = 'https://jdhcont.healthjd.com' + (url || '/');
    }
    openUrl = await getNethpHref?.()?.getRealHref?.(_url) || '';
  }
  console.log('openUrl ===>> ', openUrl);
  if(callback){
    callback(openUrl);
  }else{
    window.location.href = openUrl;
  }
}

export const handleDoctorData = (docInfo:any) => {
  let practiceCode = '';
  let _docInfo = JSON.parse(JSON.stringify(docInfo));
  let _docs:any = {
    docGoodAt: '',
    docIntro: '',
    patientEvaluationRate: '',
    receivePatientNum: ''
  };
  const isSanjia = _docInfo?.doctorTagList.some((item:any) => {
    return item.tagType === 1 && item.tagContent === '三甲';
  });

  _docInfo?.doctorDescList?.forEach((item:any) => {
    if(item.type == 'goodAt' && item.content){
      _docs.docGoodAt = item.content;
    }else if(item.type == 'doctorResume'){
      _docs.docIntro = item.content;
    }
  })

  _docInfo?.doctorServiceDataList?.forEach((item:any) => {
    if(item.title == "好评率"){
      _docs.patientEvaluationRate = item.content;
    }else if(item.title == "接诊量"){
      _docs.receivePatientNum = item.content;
    }
  })

  const practice = _docInfo?.doctorAuthenticationList?.filter((item:any) => {
    return item.type == 2;
  })

  if(practice && practice.length > 0){
    if(practice?.[0]?.content?.indexOf('：') > -1){
      const list = practice?.[0]?.content?.split?.('：');
      practiceCode = list[1];
    }else{
      practiceCode = practice?.[0]?.content || '';
    }
  }
  _docInfo = {
    ..._docInfo,
    ..._docs,
    doctorSource: 0,
    docName: _docInfo.name,
    doctorHeadImg: _docInfo.imageUrl,
    titleName: _docInfo.teacherTitle,
    doctorServiceInfoList: _docInfo.serviceList,
    hospitalGrade: isSanjia ? 3 : '',
    practiceCode: practiceCode
  }
  
  return _docInfo;
}